import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Events, ToastController } from "ionic-angular";
import { CareType } from "models/patient-chart/care-type";
import {
  AsyncReferralSummary,
  SummaryInitiateResponse,
} from "models/patient-chart/summary-types";
import * as moment from "moment";
import { BehaviorSubject } from "rxjs";
import { Observable } from "rxjs/Observable";
import { finalize, map, shareReplay, tap } from "rxjs/operators";
import { Subject } from "rxjs/Subject";
import IcdCode, { ICD_CODE_SEARCH_LIMIT } from "../../models/codes/IcdCode";
import { ContactDetails } from "../../models/contact/contactDetails";
import PhoneNumber from "../../models/contact/phone-number";
import ContentWrapper from "../../models/content-wrapper/content-wrapper";
import LookupValue from "../../models/patient-chart/lookupValue";
import { NciAddendum } from "../../models/patient-chart/nci-addendum";
import { Patient } from "../../models/patient-chart/patient";
import PatientChartBrief, {
  GetReferralSummaryResults,
  ReferralSummaryResult,
} from "../../models/patient-chart/patient-chart-brief";
import Toggle from "../../models/toggle";
import { commonVar } from "../common-var/common";
import { ConfigurationService } from "../configuration/configuration.service";
import { FacilitiesService } from "../facilities-service/facilities.service";
import { StateManagementService } from "../state-management/state-management.service";

/*
  Generated class for the ReferralsServiceProvider provider.

  See https://angular.io/guide/dependency-injec tion for more info on providers
  and Angular DI.
*/
@Injectable()
export class ReferralsServiceProvider {
  dischargeReportInformation: any;
  reportId: number;
  baseUrl: string;
  admissionHisUrl: string;
  chartUrl: string;
  private briefCache = new Map<string, Observable<PatientChartBrief>>();
  private patientByIdCache = new Map<string, Observable<Patient>>();
  notesUrl: string;
  codesUrl: string;
  apiUrl: string;
  activitiesUrl: string;
  assesmentUrl: string;
  facilityURL: string;
  headers: any;
  PATIENT_ID: any;
  CARE_TYPE: any;
  QBOS_PATIENT_CHART_ID: any;
  LEVEL_OF_CARE_ICON: string = commonVar.ADD_ICON;
  DIAGNOSIS_ICON: string = commonVar.ADD_ICON;
  PATIENT_ICON: string = commonVar.IN_PROGRESS_ICON;
  SHOW_ADMIT: boolean = true;
  ENABLE_ADMIT: boolean = false;
  CERTIFICATE_ICON: string = commonVar.ADD_ICON;
  CONSENTS_ICON: string = commonVar.ADD_ICON;
  PATIENT_PROFILE_SIDEBAR_ICON: string = commonVar.IN_PROGRESS_ICON;
  CARE_TEAM_SIDEBAR_ICON: string = commonVar.ADD_ICON;
  PATIENT_CALENDAR_ICON: string = commonVar.PATIENT_CALENDAR;
  EPRESCRIPE_SIDEBAR_ICON: string = commonVar.EPRESCRIPE_SIDEBAR;
  BENEFITS_SIDEBAR_ICON: string = commonVar.ADD_ICON;
  PATIENT_STATUS = "";
  HOME_ADDRESS: Object;
  ACTIVE_TAB_NAME: string = "profile";
  ALL_RECORD_OBTAINED: boolean = false;
  LEVEL_OF_CARE_LABEL: string;
  typeOfReport: string;
  idgDataUrl: string;
  dataBillingUrl: string;
  patientMedicationsUrl: string;

  admitStatusTimer: any;
  reportsIcon = {
    ADMISSION_INFO: commonVar.IN_PROGRESS_ICON,
    PREFERENCE: commonVar.ADD_ICON,
    ACTIVE_DIAGNOSIS: commonVar.COMPLETED_ICON,
    HEALTH_CONDITION: commonVar.ADD_ICON,
    N_MEDICATION: commonVar.ADD_ICON,
    Z_RECORD_ADMIN: commonVar.ADD_ICON,
  };
  reportsDischanrgeIcon = {
    ADMISSION_INFO: commonVar.IN_PROGRESS_ICON,
    SERVICE_UTILIZATION: commonVar.ADD_ICON,
    Z_RECORD_ADMIN: commonVar.ADD_ICON,
  };

  private _patientData = new BehaviorSubject<Patient>(null);
  public patientDataObservable = this._patientData
    .asObservable()
    .share()
    .filter((x) => {
      return x !== null;
    });

  private _certificateData = new Subject<any>();
  public certificateDataObservable = this._certificateData.asObservable();

  private _consentsData = new Subject<any>();
  public consentsDataObservable = this._consentsData.asObservable();

  private _levelOfCareDignosisData = new Subject<any>();
  public levelOfCareDignosisDataObservable =
    this._levelOfCareDignosisData.asObservable();

  public _sectionTitle = new Subject<any>();
  public sectionTitleObservable = this._sectionTitle.asObservable();

  public _reloadDeBriefBar = new Subject<any>();
  public reloadDeBriefBarObservable = this._reloadDeBriefBar.asObservable();
  public reportInformation: any = {
    administrationInfo: {},
    healthCondition: {},
    medication: {},
    preference: { F2000A: "" },
    admissionRecordAdministration: {},
  };

  TENANT_ID: any;

  newBillingFacilityToggle: boolean = false;

  setLevelOfCareLabel(levelofcare) {
    this.LEVEL_OF_CARE_LABEL = levelofcare;
  }

  getLevelofCareLabel() {
    return this.LEVEL_OF_CARE_LABEL;
  }

  constructor(
    public http: HttpClient,
    public events: Events,
    private toastCtrl: ToastController,
    private stateService: StateManagementService,
    private configurationService: ConfigurationService,
    public stateData: StateManagementService,
    public facilitiesService: FacilitiesService
  ) {
    this.baseUrl = configurationService.getConfig().referralUrl;
    this.admissionHisUrl = configurationService.getConfig().hisAdmissionUrl;
    this.notesUrl = configurationService.getConfig().notesUrl;
    this.codesUrl = configurationService.getConfig().codesUrl;
    this.activitiesUrl = configurationService.getConfig().apiUrl;
    this.assesmentUrl = configurationService.getConfig().apiUrl;
    this.headers = new HttpHeaders().set("Content-Type", "application/json");
    this.dataBillingUrl = configurationService.getConfig().billingUrl;
    this.facilityURL = configurationService.getConfig().apiUrl;
    if (this.configurationService.getConfig().apiUrl) {
      this.apiUrl = this.configurationService.getConfig().apiUrl;
    }
    this.chartUrl = this.configurationService.resolvePatientChartsUrl();
    this.idgDataUrl = configurationService.resolveIdgUrl();

    this.patientMedicationsUrl =
      configurationService.getConfig().isLocal &&
      configurationService.getConfig().localEndpoints.patientMedications
        ? configurationService.getConfig().localEndpoints.patientMedications +
          "/patient-charts/"
        : configurationService.getConfig().apiUrl +
          "/patient-medications/patient-charts/";

    this.stateData.newBillingFacility.subscribe((x) => {
      this.newBillingFacilityToggle =
        x != null ? x : this.newBillingFacilityToggle;
    });
  }

  setPatientData(patient: any) {
    // this._patientData.next(patient);
    this.events.publish("reloadBriefBarEvent", patient);
    if (patient && patient.homeAddress) {
      this.HOME_ADDRESS = patient.homeAddress;
    }
    if (patient && patient.tenant) {
      this.TENANT_ID = window.localStorage["TENANT_ID"] = patient.tenant;
    }
  }

  getDischargeAdministrativeInfo(dataUrl: string) {
    return new Observable((observer) => {
      try {
        let headers = new HttpHeaders().set("Content-Type", "application/json");
        this.http.get(dataUrl, { headers: headers }).subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err) => {
            observer.error(err);
            observer.complete();
          }
        );
      } catch (error) {}
    });
  }

  getDischargeAdminInfoList(dataUrl: string) {
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    return this.http.get(dataUrl, { headers: headers }).pipe(
      tap((reportInformation) => {
        if (dataUrl.includes("admission")) {
          this.reportInformation = reportInformation;
          this.initializeNullValues();
        } else {
          this.dischargeReportInformation = reportInformation;
          this.initializeDischargeNullValues();
        }
      })
    );
  }

  /**
   * Build a HIS admission endpoint: base + "/his/" + path, with exactly one
   * slash at each join.
   *
   * WHY THIS EXISTS — two defects, both fixed here (CO-3365).
   *
   * 1. THE URL WAS NOT EVEN VALID. `hisAdmissionUrl` ends at the port with NO
   *    trailing slash ("https://his-service.<env>.curantissolutions.com:8080")
   *    in every config from dev to prod, and every call site interpolated the
   *    path straight onto it:
   *        `${this.admissionHisUrl}lookups/typecodeinitial/PC`
   *    That yields ":8080lookups/..." — the port parses as "8080lookups", which
   *    is not a valid URL, so XMLHttpRequest.open() threw `SyntaxError: Invalid
   *    URL` and the request was NEVER SENT. Not a 404, not a CORS failure: the
   *    browser rejected it before it left the page, and the only trace was a
   *    console error, which is why it survived this long.
   *
   * 2. THE PATH ROOT WAS WRONG. HIS serves these under "/his". Every other HIS
   *    provider in this app already knows that and builds
   *    `hisAdmissionUrl + "/his/"` before appending a path — see
   *    providers/admission-his, providers/discharge-his, providers/his-service
   *    (his-data-service, hope-provider). This service was the only consumer
   *    using the bare base, so even once (1) was fixed the calls 404'd.
   *
   * Verified against dev with a real token:
   *     /lookups/typecodeinitial/PC        -> 404
   *     /his/lookups/typecodeinitial/PC    -> 200  {"PC009":[…place-of-care…]}
   *     /report/admin-info/{id}            -> 404
   *     /his/report/admin-info/{id}        -> 200  {"A0100A":…}
   *
   * IMPACT. getLookUpValue() is called by LevelOfCarePage, ReferralTabsPage and
   * StatusPage, so on the legacy (non patient-chart) path all three silently
   * never received their lookup values — and Level of Care's subscribe body
   * also calls getSymptoms(), which therefore never ran.
   *
   * Normalising here rather than editing ten config files keeps this in one
   * testable place and stays correct if a config value later gains a trailing
   * slash. Guarded by referrals-service.spec.ts.
   */
  private hisAdmissionEndpoint(path: string): string {
    const base = (this.admissionHisUrl || "").replace(/\/+$/, "");
    const suffix = String(path == null ? "" : path).replace(/^\/+/, "");
    return suffix ? `${base}/his/${suffix}` : `${base}/his`;
  }

  saveDischargeAdministrativeInfo(data: any) {
    let url = `${this.baseUrl}report/${data.patientId}/discharge`;
    if (data.type === "admission") {
      url = this.hisAdmissionEndpoint(`report/${data.patientId}/admission`);
    }
    return new Observable((observer) => {
      this.http
        .post(url, data, { headers: this.headers })
        .pipe(
          tap((response) => {
            if (url.includes("admission")) {
              this.reportInformation = response;
              this.initializeNullValues();
            } else {
              this.dischargeReportInformation = response;
              this.initializeDischargeNullValues();
            }
          })
        )
        .subscribe(
          (response) => {
            observer.next(response);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  initializeDischargeNullValues() {
    if (!this.dischargeReportInformation.serviceUtilization)
      this.dischargeReportInformation.serviceUtilization = {};
    if (!this.dischargeReportInformation.administrationInfo)
      this.dischargeReportInformation.administrationInfo = {};
    if (!this.dischargeReportInformation.recordAdministration)
      this.dischargeReportInformation.recordAdministration = {};
  }

  updateDischargeAdminInfo(data: any) {
    let url = `${this.baseUrl}report/${data.patientId}/discharge/${data.reportId}`;
    if (data.type === "admission") {
      url = this.hisAdmissionEndpoint(`report/admission/${this.reportId}`);
    }
    return new Observable((observer) => {
      try {
        let headers = new HttpHeaders().set("Content-Type", "application/json");
        this.http
          .put(url, data, { headers: headers })
          .pipe(
            tap((response) => {
              if (url.includes("admission")) {
                this.reportInformation = response;
                this.initializeNullValues();
              } else {
                this.dischargeReportInformation = response;
                this.initializeDischargeNullValues();
              }
            })
          )
          .subscribe(
            (response) => {
              observer.next(response);
              observer.complete();
            },
            (err) => {
              observer.error(err);
              observer.complete();
            }
          );
      } catch (error) {}
    });
  }

  initializeNullValues() {
    if (!this.reportInformation.healthCondition)
      this.reportInformation.healthCondition = {};

    if (!this.reportInformation.medication)
      this.reportInformation.medication = {};

    if (!this.reportInformation.preference)
      this.reportInformation.preference = { F2000A: "" };

    if (!this.reportInformation.admissionRecordAdministration)
      this.reportInformation.admissionRecordAdministration = {};
  }

  getListOfPatientReports(data: string) {
    let dataUrl = this.hisAdmissionEndpoint(`report/${data}/search`);
    return new Observable((observer) => {
      try {
        let headers = new HttpHeaders().set("Content-Type", "application/json");
        this.http.get(dataUrl, { headers: headers }).subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (err) => {
            observer.error(err);
            observer.complete();
          }
        );
      } catch (error) {}
    });
  }

  getListOfPatientDischargeReports(url: string) {
    let dataUrl = this.hisAdmissionEndpoint(url);
    return new Observable((observer) => {
      try {
        let headers = new HttpHeaders().set("Content-Type", "application/json");
        this.http.get(dataUrl, { headers: headers }).subscribe(
          (data: any) => {
            observer.next(data);
            observer.complete();
          },
          (err) => {
            observer.error(err);
            observer.complete();
          }
        );
      } catch (error) {}
    });
  }

  setCancelPath(type: string) {
    this.typeOfReport = type;
  }

  getCancelPath() {
    return this.typeOfReport;
  }

  deleteIncompleteReport(url: string) {
    return new Observable((observer) => {
      this.http.delete(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next({ data });
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  //TODO: Jessica December 22, 2020 , Consolidate, switch to getPatientById
  getPatientDetail(patientId: number, isLegacy = true) {
    let url = `${this.baseUrl}patients/` + patientId;
    return new Observable((observer) => {
      this.getPatient(url);
    });
  }

  //TODO: Jessica December 22, 2020 Refactor method name
  /*
   * Get patient chart with patient profile information by patient chart id
   */
  getPatientById(
    patientChartId: number,
    isLegacy = true,
    useExternalId: boolean = false
  ): Observable<Patient> {
    if (isLegacy === false) {
      const patientCacheKey = `${patientChartId}_${useExternalId}`;
      if (this.patientByIdCache.has(patientCacheKey)) {
        return this.patientByIdCache.get(patientCacheKey);
      }
      const shared$ = this.http
        .get(
          `${this.chartUrl}/patient-charts/${patientChartId}?expand=level_of_care,patient&externalId=${useExternalId}`,
          { headers: this.headers }
        )
        .map((data) => {
          let patient = this.mapPatientDetails(data["patient"]);
          patient = this.mapChartDatails(patient, data);
          this.TENANT_ID = patient.tenantId;
          if (data["levelOfCare"]) {
            patient.levelOfCare =
              data["levelOfCare"]["levelOfCare"]["description"];
          }
          let patientChartInfo = {
            id: patient.externalId,
            externalId: false,
            patientChartId: patient.id,
          };
          window.sessionStorage.setItem(
            "patientChartInfo",
            JSON.stringify(patientChartInfo)
          );
          window.sessionStorage.setItem(
            "externalId",
            String(patient.externalId)
          );
          window.sessionStorage.setItem("patientChartId", String(patient.id));
          window.sessionStorage.setItem("patChartId", String(patient.id));
          this.stateData.updatePatientChartStatus(patient.patientChartStatus);
          // Publish patientChartIdChange so navBarService updates its in-memory
          // values (externalId, patientChartId). Without this, sidebar navigation
          // (e.g. HIS/HOPE) builds URLs using stale patient IDs from navBarService.
          this.events.publish("patientChartIdChange", patientChartInfo);
          this.events.publish("reloadBriefBarEvent", patient);
          this.events.publish("checkMarkDiagnosis", patient);

          this._patientData.next(patient);
          return patient;
        })
        .pipe(
          finalize(() => this.patientByIdCache.delete(patientCacheKey)),
          shareReplay(1)
        );
      this.patientByIdCache.set(patientCacheKey, shared$);
      return shared$;
    } else {
      return this.http
        .get<Patient>(
          `${this.chartUrl}/patients/${patientChartId}?externalId=${useExternalId}`,
          { headers: this.headers }
        )
        .map((p) => {
          let patient = this.mapPatientDetails(p);
          patient = this.mapChartDatails(patient, p);
          if (p["levelOfCare"]) patient.levelOfCare = p["levelOfCare"];
          this.CARE_TYPE = patient.careType;
          this.QBOS_PATIENT_CHART_ID = patient.externalId;

          this.stateData.updatePatientChartStatus(patient.patientChartStatus);
          this.events.publish("reloadBriefBarEvent", patient);
          this.events.publish("checkMarkDiagnosis", patient);

          this._patientData.next(patient);
          return patient;
        });
    }
  }

  mapChartDatails(p: Patient, pc: any) {
    p.id = pc.id;
    p.teamName = pc.teamName;
    p.externalId = pc.externalId;
    p.careType = pc.careType;
    p.emergencyPreparedness = pc.emergencyPreparedness;
    p.roomNumber = pc.roomNumber;
    p.doNotResuscitateStatus = pc.doNotResuscitateStatus
      ? new LookupValue(
          pc.doNotResuscitateStatus.id,
          pc.doNotResuscitateStatus.description
        )
      : new LookupValue(0, "");
    p.awareOfReferral = pc.awareOfReferral
      ? new LookupValue(pc.awareOfReferral.id, pc.awareOfReferral.description)
      : new LookupValue(0, "");
    p.riskPriority = pc.riskPriority
      ? new LookupValue(pc.riskPriority.id, pc.riskPriority.description)
      : new LookupValue(0, "");
    p.hospiceTransferDate = pc.hospiceTransferDate;
    p.previousHospiceAdmissionDate = pc.previousHospiceAdmissionDate;

    p.livingWill = pc.livingWill;
    p.skilledBed = pc.skilledBed;
    p.daysRemaining = pc.daysRemaining;

    p.diagnosis = pc.diagnosis;

    if (pc.referralAddress) {
      p.referralAddress = pc.referralAddress
        ? new ContactDetails(
            pc.referralAddress.address1,
            "",
            pc.referralAddress.city,
            pc.referralAddress.state,
            pc.referralAddress.zip,
            pc.referralAddress.zipExtension,
            pc.referralAddress.phone,
            pc.referralAddress.emailAddress,
            pc.referralAddress.emailAddress,
            pc.referralAddress.county,
            pc.referralAddress.fax
          )
        : new ContactDetails();
      p.referralAddress.locationTypeId = pc.referralAddress.locationTypeId;
      p.referralAddress.name = pc.referralAddress.name;
    }
    p.patientChartStatus = pc.patientStatus;
    p.dischargedReason = pc.dischargedReason;
    p.tenantId = pc.tenantId;
    p.admittedDatetime = pc.admittedDatetime;
    p.dischargedDatetime = pc.dischargedDatetime;

    return p;
  }

  mapPatientDetails(p: any) {
    let phoneNumber: PhoneNumber = new PhoneNumber();

    if (p.phoneNumber) {
      phoneNumber = new PhoneNumber(
        p.phoneNumber.id,
        p.phoneNumber.number,
        p.phoneNumber.extension,
        p.phoneNumber.phoneNumberType.toString()
      );
    }
    let patient = new Patient();
    patient.patientId = p.id;
    patient.age = p.age;
    patient.birthDate = p.birthDate;
    patient.firstName = p.firstName;
    patient.lastName = p.lastName;
    patient.fullName = p.fullName;
    patient.middleInitial = p.middleInitial;
    patient.nickName = p.nickName;
    patient.prefix = p.prefix
      ? new LookupValue(p.prefix.id, p.prefix.description)
      : new LookupValue(0, "");
    patient.suffix = p.suffix
      ? new LookupValue(p.suffix.id, p.suffix.description)
      : new LookupValue(0, "");

    patient.firstLanguage = p.firstLanguage
      ? new LookupValue(p.firstLanguage.id, p.firstLanguage.description)
      : new LookupValue(0, "");
    patient.ethnicities = p.ethnicities
      ? new LookupValue(p.ethnicities.id, p.ethnicities.description)
      : new LookupValue(0, "");
    patient.hopeEthnicities = p.hopeEthnicities
      ? new LookupValue(p.hopeEthnicities.id, p.hopeEthnicities.description)
      : new LookupValue(0, "");
    patient.hopeRaces = p.hopeRaces
      ? new LookupValue(p.hopeRaces.id, p.hopeRaces.description)
      : new LookupValue(0, "");
    patient.gender = p.gender
      ? new LookupValue(p.gender.id, p.gender.description)
      : new LookupValue(0, "");
    patient.maritalStatus = p.maritalStatus
      ? new LookupValue(p.maritalStatus.id, p.maritalStatus.description)
      : new LookupValue(0, "");
    patient.religion = p.religion
      ? new LookupValue(p.religion.id, p.religion.description)
      : new LookupValue(0, "");
    patient.religionOtherText = p.religionOtherText || "";
    patient.veteran = p.veteran;
    patient.ssnUnknown = p.ssnUnknown;

    patient.emailAddress = p.emailAddress;
    patient.phoneNumber = phoneNumber;
    patient.homeAddress = p.homeAddress
      ? new ContactDetails(
          p.homeAddress.address1,
          "",
          p.homeAddress.city,
          p.homeAddress.state,
          p.homeAddress.zip,
          p.homeAddress.zipExtension,
          p.homeAddress.phone,
          p.homeAddress.emailAddress,
          p.homeAddress.emailAddress,
          p.homeAddress.county
        )
      : new ContactDetails();

    patient.uniqueIdentifier = p.uniqueIdentifier;

    return patient;
  }

  getPatient(dataUrl: string) {
    return new Observable((observer) => {
      try {
        let headers = new HttpHeaders().set("Content-Type", "application/json");
        this.http.get(dataUrl, { headers: headers }).subscribe(
          (data) => {
            this.setPatientData(data);
            observer.next(data);
            observer.complete();
          },
          (err) => {
            observer.error(err);
            observer.complete();
          }
        );
      } catch (error) {}
    });
  }

  getReferralsList(
    page: number,
    size: number,
    orderBy: string,
    direction: string,
    searchTerm: string,
    status: string,
    eligibility: string,
    careType: string
  ) {
    const orgTimezone =
      window.localStorage.getItem("orgTimezone") || "America/Chicago";
    return new Observable((observer) => {
      this.http
        .get(
          `${
            this.chartUrl
          }/patient-charts?page=${page}&limit=${size}&by=${orderBy}&direction=${direction}&q=${searchTerm}&status=${status}&eligibility=${eligibility}&careType=${careType}&timezone=${encodeURIComponent(
            orgTimezone
          )}`,
          { headers: this.headers }
        )
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  getPatientChartList(params: Record<string, any>) {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        queryParams.append(key, value.toString());
      }
    });

    return new Observable((observer) => {
      this.http
        .get(`${this.chartUrl}/patient-charts?${queryParams.toString()}`, {
          headers: this.headers,
        })
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  postPhysicianSubmit(data, physicianType, patient_id, create) {
    let url: string = `${this.baseUrl}physicians/patients/${patient_id}?physicianType=${physicianType}`;
    return new Observable((observer) => {
      const newLocal = create
        ? this.http.post(url, data, { headers: this.headers })
        : this.http.put(url, data, { headers: this.headers });
      newLocal.subscribe(
        (response) => {
          observer.next(response);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  markAsAbsence(patientId, facilityType) {
    let url: string = `${this.baseUrl}patients/${patientId}/facilities/type/${facilityType}/mark/absence`;
    return new Observable((observer) => {
      this.http.put(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  markAsAbsenceForHospice(patientId) {
    let url: string = `${this.baseUrl}/hospice/mark/absence/${patientId}`;
    return new Observable((observer) => {
      this.http.put(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  saveLocation(data, patientId) {
    let url: string = `${this.baseUrl}services/patient/${patientId}`;
    return new Observable((observer) => {
      this.http.post(url, data, { headers: this.headers }).subscribe(
        (response) => {
          observer.next(response);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  getLocation(facilityType, searchTerm = "") {
    return new Observable((observer) => {
      let url: string;
      if (facilityType === "") {
        // Remove this when location api integrated in all the popups
        url = "http://www.mocky.io/v2/5bed55383300000f21a295ae";
      } else {
        url = `${this.baseUrl}services?search=${searchTerm}&type=${facilityType}`;
      }
      this.http
        .get(url, {
          headers: this.headers,
        })
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  updateLocation(data, patientId) {
    let url: string = `${this.baseUrl}services/patient/${patientId}`;
    return new Observable((observer) => {
      this.http.put(url, data, { headers: this.headers }).subscribe(
        (response) => {
          observer.next(response);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  deleteLocation(patientId, facilityType) {
    let url: string = `${this.baseUrl}services/patient/${patientId}/${facilityType}`;
    return new Observable((observer) => {
      this.http.delete(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next({ data, patientId, facilityType });
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  markAsAbsenceLocation(patientId, facilityType) {
    let url: string = `${this.baseUrl}/services/patient/${patientId}/mark/absence/${facilityType}`;
    return new Observable((observer) => {
      this.http.put(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  postCallerSubmitData(data, type, id: number) {
    let url: string = `${this.baseUrl}contacts/patient/${id}/callerReferrer?contactType=${type}`;
    return new Observable((observer) => {
      this.http.put(url, data, { headers: this.headers }).subscribe(
        (response) => {
          observer.next(response);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  /*
    Get Caller/Referral details for patient

    */
  getCallerData(url) {
    return new Observable((observer) => {
      this.http
        .get(`${this.baseUrl}${url}`, { headers: this.headers })
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  /*
    Save/Update Caller/Referral details for patient

    */
  saveCallerData(url, data): Observable<any> {
    return new Observable((observer) => {
      this.http
        .put(`${this.baseUrl}${url}`, JSON.stringify(data), {
          headers: this.headers,
        })
        .subscribe(
          (response) => {
            observer.next(response);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  /**
   * save hospice data
   * @param hospiceTransferData
   * @param {number} id
   * @returns {Observable<any>}
   */
  createHospiceTransfer(hospiceTransferData: any, id: number) {
    let url: string = `${this.baseUrl}hospice/patient/${id}/`;
    return new Observable((observer) => {
      this.http
        .post(url, JSON.stringify(hospiceTransferData), {
          headers: this.headers,
        })
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  /**
   * save hospice data
   * @param hospiceTransferData
   * @param {number} id
   * @returns {Observable<any>}
   */
  updateHospiceTransfer(hospiceTransferData: any, id: number) {
    let url: string = `${this.baseUrl}hospice/patient/${id}/`;
    return new Observable((observer) => {
      this.http
        .put(url, JSON.stringify(hospiceTransferData), {
          headers: this.headers,
        })
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  deleteHospiceTransfer(patientId) {
    let url: string = `${this.baseUrl}hospice/patient/${patientId}`;
    return new Observable((observer) => {
      this.http.delete(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next({ data, patientId });
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  // County by state + zip via the address-functions Lambda. The getCounty()
  // below hits a decommissioned stub (empty 200 body, CO-2284) — this is the
  // working lookup (DFND-5302 / CO-3029). facilityURL === config apiUrl.
  getCountyByStateAndZipCode(state, zipCode) {
    return this.http.get(
      `${this.facilityURL}/address/state/${state}/zip/${zipCode}`,
      { headers: this.headers }
    );
  }

  // get County
  getCounty(zipCode) {
    let url = `${this.baseUrl}zip/${zipCode}`;
    return new Observable((observer) => {
      // change mocky url after getting api
      this.http
        .get(url, {
          headers: this.headers,
        })
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  postReferralsCredit(referralCreditData: any) {
    let url: string = `${this.baseUrl}refcredit`;
    return new Observable((observer) => {
      this.http
        .post(url, JSON.stringify(referralCreditData), {
          headers: this.headers,
        })
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  deleteReferralsCredit(patientId) {
    let url: string = `${this.baseUrl}refcredit/${patientId}`;
    return new Observable((observer) => {
      this.http.delete(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next({ data, patientId });
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  putReferralsCredit(referralCreditData: any, id: number) {
    let url: string = `${this.baseUrl}refcredit/${id}`;
    return new Observable((observer) => {
      this.http
        .put(url, JSON.stringify(referralCreditData), {
          headers: this.headers,
        })
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  getLocData(id) {
    let lookupUrl = `${this.chartUrl}/patient-charts/${id}/level-of-care`;

    return new Observable((observer) => {
      this.http.get(lookupUrl, { headers: this.headers }).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  getLocHistoryDataById(
    patientChartId,
    levelOfCareId,
    newBillingFacilityToggle
  ) {
    let lookupUrl = `${this.chartUrl}/patient-charts/${patientChartId}/level-of-care-history/${levelOfCareId}?facilityToggle=${newBillingFacilityToggle}`;

    return new Observable((observer) => {
      this.http.get(lookupUrl, { headers: this.headers }).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  getLocFacility(id) {
    if (this.newBillingFacilityToggle) {
      return new Observable((observer) => {
        this.facilitiesService.getFacilityById(id).subscribe(
          (data) => {
            let mappedFacility = {
              id: data.facilityId,
              name: data.facilityName,
              facilityType: data.facilityType,
              externalId: "",
              npi: data.npi,
              address: new ContactDetails(),
            };
            mappedFacility.id = data.facilityId;
            mappedFacility.name = data.facilityName;
            mappedFacility.facilityType = data.facilityType;
            mappedFacility.externalId = "";
            mappedFacility.npi = data.npi;
            if (data.streetAddress) {
              mappedFacility.address.address1 = data.streetAddress.address1;
              mappedFacility.address.address2 = data.streetAddress.address2;
              mappedFacility.address.city = data.streetAddress.city;
              mappedFacility.address.state = data.streetAddress.state;
              mappedFacility.address.county = data.streetAddress.county;
              mappedFacility.address.email = data.email;
              mappedFacility.address.emailAddress = data.email;
              mappedFacility.address.zip = data.streetAddress.zipCode.substring(
                0,
                5
              );
              mappedFacility.address.zipExtension =
                data.streetAddress.zipCode.slice(-4);
            }

            if (data.phones && data.phones.length > 0) {
              data.phones.map((p) => {
                if (p.isPrimary) mappedFacility.address.phone = p.number;
                if (p.type === "FAX") mappedFacility.address.fax = p.number;
              });
            }

            observer.next(mappedFacility);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
      });
    } else {
      let lookupUrl = `${this.facilityURL}/company-resources/facilities/${id}`;
      return new Observable((observer) => {
        this.http.get(lookupUrl, { headers: this.headers }).subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
      });
    }
  }

  getIcdCodeSearch(searchKey) {
    let url = this.codesUrl;
    if (this.apiUrl && this.apiUrl !== "") {
      url = this.apiUrl;
    }

    // `limit` is sent ahead of `q` on purpose: searchKey is interpolated raw, so
    // an "&" typed into the box would otherwise swallow the limit parameter.
    return this.http.get<ContentWrapper<IcdCode>>(
      `${url}/icd-codes?limit=${ICD_CODE_SEARCH_LIMIT}&q=${searchKey}`,
      { headers: this.headers }
    );
  }

  getLocHistoryData(id) {
    let lookupUrl = `${this.baseUrl}loc/history/patient/${id}`;

    return new Observable((observer) => {
      this.http.get(lookupUrl, { headers: this.headers }).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  getLookUpValue() {
    let lookupUrl = this.hisAdmissionEndpoint("lookups/typecodeinitial/PC");

    const isNewPatientChart = this.stateService.isPatientChart.getValue();

    if (isNewPatientChart) {
      lookupUrl = `${this.chartUrl}/patient-charts/lookups`;
    }

    return new Observable((observer) => {
      this.http.get(lookupUrl, { headers: this.headers }).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  getLookUpValueByCode(code: string) {
    let lookupUrl = `${this.baseUrl}lookups/typecode/${code}`;

    return new Observable((observer) => {
      this.http.get(lookupUrl, { headers: this.headers }).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  postPhysicianOrder(physicianOrderValue: any) {
    let url: string = `${this.baseUrl}patients/physician/order`;
    return new Observable((observer) => {
      this.http
        .post(url, JSON.stringify(physicianOrderValue), {
          headers: this.headers,
        })
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  deletePhysicianOrder(patientId) {
    let url: string = `${this.baseUrl}patients/${patientId}/physician/order`;
    return new Observable((observer) => {
      this.http.delete(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next({ data, patientId });
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  postLevelOfCareData(levelOfCareData: any) {
    let url: string = `${this.baseUrl}loc`;
    return new Observable((observer) => {
      this.http
        .post(url, JSON.stringify(levelOfCareData), { headers: this.headers })
        .subscribe(
          (data) => {
            this._levelOfCareDignosisData.next(data);
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  delete(id: number, contactType: string) {
    let url: string = `${this.baseUrl}contacts/patient/${id}/type/${contactType}`;
    return new Observable((observer) => {
      this.http.delete(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next({ data, id, contactType });
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  findPatientBySSN(ssn: string) {
    let url: string = `${this.baseUrl}patients/ssn/${ssn}`;
    return new Observable((observer) => {
      this.http.get(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  getLocationAsPerCareLocationType(careLocationType) {
    let url = `${this.baseUrl}carelocations/search?type=${careLocationType}`;
    return new Observable((observer) => {
      this.http
        .get(url, {
          headers: this.headers,
        })
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  getLocationAsPerLocationType(careLocationType) {
    let url = `${this.baseUrl}carelocations/search?type=${careLocationType}`;
    return new Observable((observer) => {
      // change mocky url after getting api
      this.http
        .get(url, {
          headers: this.headers,
        })
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  getLocationByCareLocationType(careLocationType) {
    let url = `${this.baseUrl}carelocations/search?type=${careLocationType}`;
    return new Observable((observer) => {
      // change mocky url after getting api
      this.http
        .get(url, {
          headers: this.headers,
        })
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  /**
   * Search Physician
   * @param searchText
   */
  getPhysicianData(searchText) {
    let url = `${this.baseUrl}physicians/search?searchKey=${searchText}`;
    return new Observable((observer) => {
      this.http.get(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  /**
   * Create/update consents for a patient
   * @param ConsentsData
   * @param patientChartId
   */
  submitConsents(ConsentsData: any, patientChartId: string) {
    let url = `${this.chartUrl}/patient-charts/${patientChartId}/consents`;
    return new Observable((observer) => {
      this.http.put(url, ConsentsData, { headers: this.headers }).subscribe(
        (data) => {
          this._consentsData.next(data);
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  /**
   * Create Certificatcate details for a patient
   * @param CertificatcateData
   * @param patientId
   */
  submitCertificatcateData(CertificatcateData: any, patientId: string) {
    let url: string = `${this.baseUrl}certifications/patients/${patientId}/certificates`;
    return new Observable((observer) => {
      this.http
        .post(url, JSON.stringify(CertificatcateData), {
          headers: this.headers,
        })
        .subscribe(
          (data) => {
            this._certificateData.next(data);
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  /**
   * Update Certificatcate details for a patient
   * @param CertificatcateData
   * @param patientId
   */
  updateCertificatcateData(CertificatcateData: any, patientId: string) {
    let url: string = `${this.baseUrl}certifications/patients/${patientId}/certificates/${CertificatcateData.id}`;
    return new Observable((observer) => {
      this.http
        .put(url, JSON.stringify(CertificatcateData), {
          headers: this.headers,
        })
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  /**
   * delete Certificate Data
   * @param patientId
   * @returns {Observable<any>}
   */
  deleteCertificateData(patientId, certificateId) {
    let url: string = `${this.baseUrl}certifications/patients/${patientId}/certificates/${certificateId}`;
    return new Observable((observer) => {
      this.http.delete(url, { headers: this.headers }).subscribe(
        (data) => {
          this._certificateData.next(data);
          observer.next({ data, patientId });
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  /**
   * fetch Consents Data
   * @param patientId
   */
  getConsentsData(patientId: string) {
    let url = `${this.chartUrl}/patient-charts/${patientId}/consents`;

    return new Observable((observer) => {
      this.http.get(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  /**
   * Fetch Non-Covered Items (NCI) Addendums for a patient.
   *
   * ============================================================================
   * NCI ADDENDUMS DATA FLOW & FIELD MAPPING
   * ============================================================================
   *
   * This API returns addendum records that are displayed in the "Non-Covered Items'
   * Addendums" grid on the Consents Details page (consents-details.ts).
   *
   * FIELD TYPES & DATA SOURCES:
   * ---------------------------
   * The response contains IDs that reference two different entity types:
   *
   * 1. RESOURCE IDs (Company Resources / Providers):
   *    - deliveredById: ID of the resource/provider who delivered the addendum
   *    - Fetched via: ResourceManagementService.getProviderByExternalId()
   *    - Display format: "lastName, firstName (credentials)" using findDisplayName()
   *    - Loaded lazily when row details are expanded (for performance)
   *
   * 2. CAREGIVER IDs (Patient Contacts/Caregivers):
   *    - deliveredToId: ID of the caregiver the addendum was delivered to
   *    - acknowledgedById: ID of the caregiver who acknowledged the addendum
   *    - Fetched via: CareTeamsService.getPatientCaregivers()
   *    - Display format: "relationship - firstName lastName" (e.g., "Daughter - Kelly Walton")
   *    - Loaded upfront with addendums using forkJoin (needed for row display)
   *
   * DISPLAY MAPPING IN consents-details.ts:
   * ---------------------------------------
   * API Field           -> Display Field      -> Source
   * ------------------------------------------------------------------
   * deliveredById       -> deliveryByName     -> Resource API (lazy loaded)
   * deliveredToId       -> deliveryToName     -> Caregiver API (upfront)
   * deliveredToId       -> declineByName      -> Caregiver API (same as deliveryTo)
   * acknowledgedById    -> acknowledgeBy      -> Caregiver API (upfront, shown in row)
   * deliveredDatetime   -> declineDate        -> Direct mapping (for declined status)
   * declinedByReason    -> declineReason      -> Direct mapping
   *
   * @param patientId - The patient's ID (qBosId)
   * @param page - Zero-based page index (default 0)
   * @param size - Page size (default 10, server clamps max at 100)
   * @returns Observable<ContentWrapper<NciAddendum>> - Full Spring `Page<T>`
   *          envelope including `content`, `totalPages`, `totalElements`, etc.
   *          Caller picks what it needs (PR #1129 follow-up #3 wires real
   *          pagination controls on the Consents page; older callers were
   *          unwrapping `.content` themselves, so we now return the envelope
   *          and let component code do the same explicitly — type honesty).
   */
  getNciAddendums(
    patientId: string,
    page: number = 0,
    size: number = 10
  ): Observable<ContentWrapper<NciAddendum>> {
    const url = `${this.chartUrl}/patient-charts/${patientId}/nci-addendums`;
    // Spring Boot pagination: 0-based `page` index, `size` clamped to 100 by
    // the patient-charts controller (see NonCoveredItemsAddendumController).
    const params = new HttpParams()
      .set("page", String(page))
      .set("size", String(size));
    return this.http.get<ContentWrapper<NciAddendum>>(url, {
      headers: this.headers,
      params,
    });

    // =========================================================================
    // MOCK DATA FOR DEVELOPMENT/TESTING
    // =========================================================================
    // This mock data includes a mix of REAL and DUMMY IDs to test error handling:
    // - Real IDs will resolve to actual names
    // - Dummy IDs (99999, 88888) will trigger "Not Found" / "Unknown" fallback text
    // =========================================================================

    // // Resource IDs for testing lazy load via ResourceManagementService
    // // - Real IDs: 1000421, 1000371, 1000425, 755161 (should resolve to provider names)
    // // - Dummy ID: 99999 (should show "Not Found (ID: 99999)")
    // const deliveredByIds = [1000421, 1000371, 99999, 1000425, 755161];

    // // Caregiver IDs for testing via CareTeamsService.getPatientCaregivers()
    // // Real IDs match actual patient contacts from the caregivers API response:
    // // - 7941: Kelly Walton (Daughter, Primary Caregiver)
    // // - 8107: Day Zimmarman (Guardian, Secondary Caregiver)
    // // - 8108: John Sena (Guardian, Additional Caregiver)
    // // Dummy ID: 88888 (should show "Unknown (ID: 88888)")
    // const caregiverIds = [7941, 8107, 88888, 8108];

    // const mockData = [];

    // // First record - only Generation Date/Time with document attachment
    // mockData.push({
    //   id: 0,
    //   patientChartId: 12345,
    //   generationDatetime: "2026-01-06T10:30:00Z", // 01/06/2026 04:30 (CST)
    //   requestedDatetime: null,
    //   deliveredDatetime: null,
    //   acknowledgedDatetime: null,
    //   deliveryMethod: null,
    //   deliveredById: null,
    //   deliveredToId: null,
    //   deliveredToPatient: null,
    //   deliveredToRelationship: null,
    //   addendumStatus: null,
    //   declinedByReason: null,
    //   requestedBy: null,
    //   acknowledgedById: null,
    //   acknowledgedByRelationship: null,
    //   documentAttachmentId: 14579,
    //   createdBy: "admin@curantis.com",
    //   updatedBy: "admin@curantis.com",
    //   createdDatetime: "2026-01-05T14:00:00Z",
    //   updatedDatetime: "2026-01-06T11:00:00Z",
    // });

    // for (let i = 0; i < 10; i++) {
    //   const status = ["Signed", "Delivered", "Declined", "Unsigned", "Sent"][
    //     i % 5
    //   ];
    //   const isDeclined = status === "Declined";
    //   mockData.push({
    //     id: i + 1,
    //     patientChartId: 12345,
    //     generationDatetime: "2026-01-06T10:30:00Z",
    //     requestedDatetime: "2026-01-05T14:00:00Z",
    //     deliveredDatetime: "2026-01-06T10:30:00Z",
    //     acknowledgedDatetime: "2026-01-06T11:00:00Z",
    //     deliveryMethod: ["In-Person", "Email", "Mail", "Fax", "Verbal"][i % 5],

    //     // Resource ID - fetched via ResourceManagementService.getProviderByExternalId()
    //     // Displayed as: "lastName, firstName (credentials)"
    //     // Uses modulo 5 to cycle through array including dummy ID (99999)
    //     deliveredById: deliveredByIds[i % 5],

    //     // Caregiver ID - fetched via CareTeamsService.getPatientCaregivers()
    //     // Displayed as: "relationship - firstName lastName"
    //     // Also used for declineByName when status is "Declined"
    //     // Uses modulo 4 to cycle through array including dummy ID (88888)
    //     deliveredToId: caregiverIds[i % 4],

    //     deliveredToPatient: true,
    //     deliveredToRelationship: null,
    //     addendumStatus: status,

    //     // Only populated when status is "Declined"
    //     declinedByReason: isDeclined ? "Family, they did not want it." : null,

    //     requestedBy: "Dr. Smith",

    //     // Caregiver ID - fetched via CareTeamsService.getPatientCaregivers()
    //     // Displayed in main row as: "relationship - firstName lastName"
    //     // Uses modulo 4 to cycle through array including dummy ID (88888)
    //     acknowledgedById: caregiverIds[i % 4],

    //     acknowledgedByRelationship: "Self",
    //     documentAttachmentId: 5001,
    //     createdBy: "admin@curantis.com",
    //     updatedBy: "admin@curantis.com",
    //     createdDatetime: "2026-01-05T14:00:00Z",
    //     updatedDatetime: "2026-01-06T11:00:00Z",
    //   });
    // }

    // return new Observable((observer) => {
    //   setTimeout(() => {
    //     observer.next(mockData);
    //     observer.complete();
    //   }, 500);
    // });
  }

  /**
   * Update an NCI Addendum record.
   *
   * PUT /patient-charts/{patientChartId}/nci-addendum/{nciAddendumId}
   *
   * @param patientChartId - The patient chart ID
   * @param nciAddendumId - The NCI Addendum record ID
   * @param payload - The updated addendum data
   * @returns Observable with the updated addendum
   */
  updateNciAddendum(
    patientChartId: number,
    nciAddendumId: number,
    payload: any
  ): Observable<any> {
    const url = `${this.chartUrl}/patient-charts/${patientChartId}/nci-addendum/${nciAddendumId}`;
    return this.http.put<any>(url, payload, { headers: this.headers });
  }

  /**
   * fetch Certificatcate List
   * @param patientId
   */
  getCertificationList(patientId: string, url) {
    return new Observable((observer) => {
      this.http
        .get(
          `${this.baseUrl}certifications/patients/${patientId}/certificates/all?${url}`,
          { headers: this.headers }
        )
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  /**
   * fetch Certificatcate Data
   * @param patientId
   */
  getCertificatcateData(patientId: string) {
    let url = `${this.baseUrl}certifications/patients/${patientId}/certificates`;
    return new Observable((observer) => {
      this.http.get(url, { headers: this.headers }).subscribe(
        (data) => {
          this._certificateData.next(data);
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  // Check admit status of patient
  checkAdmitStatus(patientID: string) {
    let url = `${this.baseUrl}patients/${patientID}/admitstatus`;

    return new Observable((observer) => {
      this.http.get(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  getPatientActivity(dataUrl: string) {
    return new Observable((observer) => {
      try {
        let headers = new HttpHeaders().set("Content-Type", "application/json");
        this.http.get(dataUrl, { headers: headers }).subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err) => {
            observer.error(err);
            observer.complete();
          }
        );
      } catch (error) {}
    });
  }

  checkIfNPIAlreadyExists(npi: string) {
    let url: string = `${this.baseUrl}physicians/npi?npi=${npi}`;
    return new Observable((observer) => {
      this.http.get(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  // wrong URL on /brief
  // getUserBriefData(patientId) {
  //     let url = `${this.baseUrl}patients/${patientId}/brief?useQbos=false`;
  //     return new Observable(observer => {
  //         this.http.get(url, {headers: this.headers}).subscribe(
  //             data => {
  //                 observer.next(data);
  //                 observer.complete();
  //             },
  //             (err: HttpErrorResponse) => {
  //                 observer.error(err);
  //                 observer.complete();
  //             }
  //         );
  //     });
  // }

  getLookUpValuesForAdverseEvents() {
    return this.http.get(`${this.notesUrl}/notes/lookups`);
  }

  createNote(data: any, patientChartId: string) {
    let url: string = `${this.notesUrl}/patient-charts/${patientChartId}/notes`;
    return new Observable((observer) => {
      this.http
        .post(url, JSON.stringify(data), {
          headers: this.headers,
        })
        .subscribe(
          (response) => {
            observer.next(response);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  updateNote(data: any, id: string, patientChartId: string) {
    let url: string = `${this.notesUrl}/patient-charts/${patientChartId}/notes/${id}`;
    return new Observable((observer) => {
      this.http
        .put(url, JSON.stringify(data), {
          headers: this.headers,
        })
        .subscribe(
          (response) => {
            observer.next(response);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  deleteNote(noteId, patientChartId: string) {
    let url: string = `${this.notesUrl}/patient-charts/${patientChartId}/notes/${noteId}`;
    return new Observable((observer) => {
      this.http.delete(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next({ data, patientChartId });
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  getSectionTitle() {
    if (this.sectionTitleObservable) {
      return this.sectionTitleObservable;
    }
  }

  setSectionTitle(value: any) {
    if (this._sectionTitle) {
      this._sectionTitle.next(value);
    }
  }

  getReloadDeBriefBar() {
    if (this.reloadDeBriefBarObservable) {
      return this.reloadDeBriefBarObservable;
    }
  }

  setReloadDeBriefBar(value: any) {
    if (this._reloadDeBriefBar) {
      this._reloadDeBriefBar.next(value);
    }
  }

  getAssesmentNotes(url: string) {
    url = `${this.assesmentUrl}/${url}`;
    return new Observable((observer) => {
      this.http.get(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  getDiciplines() {
    let url = `${this.baseUrl}lookups/discipline`;
    return new Observable((observer) => {
      this.http.get(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  /**
   * get patient activity
   * @param {any} patientId
   * @returns {Observable<any>}
   */
  getActivity(patientId: any) {
    let url = `${this.activitiesUrl}/patient-charts/${patientId}/activities`;
    return new Observable((observer) => {
      this.http.get(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  // ** */
  generateMedReport(patId) {
    return new Observable((observer) => {
      this.http
        .get(
          `${this.idgDataUrl}/orders/patient-charts/${this.QBOS_PATIENT_CHART_ID}/generate_medication_profile_report`,
          { responseType: "arraybuffer" }
        )
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  /**
   * fetch payers Data
   * @param patientId
   */
  getPayersData(patientId: string) {
    let url = `${this.baseUrl}certifications/patients/${patientId}/payers`;
    return new Observable((observer) => {
      this.http.get(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  /**
   * fetch admin info
   * @param patientId
   */
  getAdminData(patientId: number) {
    let url = this.hisAdmissionEndpoint(`report/admin-info/${patientId}`);
    return new Observable((observer) => {
      this.http.get(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  getBenefitStatus(patientChartId) {
    let url = `${this.dataBillingUrl}/benefits/patient/status/${patientChartId}`;
    return new Observable((observer) => {
      this.http.get(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  getPatientChartBrief(
    patientChartId: number,
    useExternalId: boolean = false,
    featureIsOn: boolean = false,
    toggle: Toggle = null
  ): Observable<PatientChartBrief> {
    //let version = "1";
    //if (featureIsOn) {
    //    version = "2";
    //}
    // defaulting to version="2" since all patients are now in NPC
    let version = "2";
    let toggleParam = "&showPalliativeV1_5=";
    if (toggle && toggle.showPalliativeV1_5 === true) {
      toggleParam += "true";
    } else {
      toggleParam += "false";
    }
    let patientChartInfo = JSON.parse(
      window.sessionStorage.getItem("patientChartInfo")
    );
    let validPatientChartId: number;
    // Cross-patient guard: only trust sessionStorage when the parameter
    // refers to the same patient. If the parameter doesn't match either
    // patientChartInfo.id (external) or patientChartInfo.patientChartId
    // (internal), sessionStorage holds a different patient — ignore it
    // and use the parameter directly.
    const sessionMatchesParam =
      patientChartInfo &&
      patientChartId &&
      (Number(patientChartId) === Number(patientChartInfo.id) ||
        Number(patientChartId) === Number(patientChartInfo.patientChartId));
    if (patientChartInfo && sessionMatchesParam) {
      // When useExternalId is true, use the external/QBOS ID (patientChartInfo.id),
      // not the internal patientChartId — they are different values
      validPatientChartId = useExternalId
        ? patientChartInfo.id || patientChartId
        : patientChartInfo.patientChartId || patientChartId;
      // Safety net: if the resolved ID equals the external ID (patientChartInfo.id)
      // but differs from the internal ID, we're about to send the external ID
      // with useExternalId=false — correct it to use the internal ID instead.
      if (
        !useExternalId &&
        Number(validPatientChartId) === Number(patientChartInfo.id) &&
        Number(patientChartInfo.patientChartId) !==
          Number(patientChartInfo.id) &&
        patientChartInfo.patientChartId
      ) {
        validPatientChartId = patientChartInfo.patientChartId;
      }
    } else {
      // sessionStorage empty or holds a different patient — trust the
      // parameter. Apply the URL heuristic to detect external IDs:
      // IDs < 199999 are likely external/QBOS IDs.
      if (!useExternalId && patientChartId < 199999) {
        useExternalId = true;
      }
      validPatientChartId = patientChartId;
    }

    const briefCacheKey = `${validPatientChartId}_${useExternalId}${toggleParam}`;
    if (this.briefCache.has(briefCacheKey)) {
      return this.briefCache.get(briefCacheKey);
    }

    const shared$ = this.http
      .get<PatientChartBrief>(
        `${this.chartUrl}/patient-charts/${validPatientChartId}/brief?useExternalId=${useExternalId}&version=${version}${toggleParam}`
      )
      .map(
        (x) => {
          let patientChartBrief = new PatientChartBrief();
          patientChartBrief.gender = x.gender;
          patientChartBrief.firstName = x.firstName;
          patientChartBrief.lastName = x.lastName;
          patientChartBrief.codeStatus = x.codeStatus;
          patientChartBrief.riskPriority = x.riskPriority;
          patientChartBrief.birthDate = x.birthDate;
          patientChartBrief.age = x.age;
          patientChartBrief.primaryDiagnosisCode = x.primaryDiagnosisCode;
          patientChartBrief.primaryDiagnosisDescription =
            x.primaryDiagnosisDescription;
          patientChartBrief.secondaryDiagnosisCode = x.secondaryDiagnosisCode;
          patientChartBrief.secondaryDiagnosisDescription =
            x.secondaryDiagnosisDescription;
          patientChartBrief.visitDiagnoses = x.visitDiagnoses;
          patientChartBrief.levelOfCare = x.levelOfCare;
          patientChartBrief.comorbiditiesDiagnosisDescription =
            x.comorbiditiesDiagnosisDescription;
          patientChartBrief.attendingPhysicianName = x.attendingPhysicianName;
          patientChartBrief.attendingPhysicianPhoneNumber =
            x.attendingPhysicianPhoneNumber;
          patientChartBrief.primaryCareGiverName = x.primaryCareGiverName;
          patientChartBrief.primaryCareGiverPhoneNumber =
            x.primaryCareGiverPhoneNumber;
          patientChartBrief.foodAllergies = x.foodAllergies;
          patientChartBrief.drugAllergies = x.drugAllergies;
          patientChartBrief.prefix = x.prefix;
          patientChartBrief.suffix = x.suffix;
          patientChartBrief.externalId = x.externalId;
          patientChartBrief.careLocation = x.careLocation;
          patientChartBrief.benefitPeriod = x.benefitPeriod;
          patientChartBrief.careType = x.careType;

          if (patientChartBrief.gender) {
            if (patientChartBrief.gender.id === 1) {
              // male
              patientChartBrief.profileImagePath = "assets/mantis/male.jpg";
            } else if (patientChartBrief.gender.id === 2) {
              // female
              patientChartBrief.profileImagePath = "assets/mantis/female.jpg";
            }
          }
          if (x.serviceDate) {
            patientChartBrief.serviceDate = x.serviceDate;
          }
          return patientChartBrief;
        },
        (e) => {
          console.error(e);
        }
      )
      .pipe(
        finalize(() => this.briefCache.delete(briefCacheKey)),
        shareReplay(1)
      );

    this.briefCache.set(briefCacheKey, shared$);
    return shared$;
  }

  getPatientChartIntakeReferralLookups() {
    return this.http.get<Record<string, LookupValue[]>>(
      `${this.chartUrl}/patient-charts/referral-intake-lookups`
    );
  }

  formatDate(date) {
    return date ? moment(date).format("MM-DD-YYYY") : null;
  }

  prePopulateAdmissionReport() {
    return this.http.get(
      this.hisAdmissionEndpoint(
        `report/${this.PATIENT_ID}/admission/getAdmissionReport`
      )
    );
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: "below",
      cssClass: "error",
    });

    toast.onDidDismiss(() => {});

    toast.present();
  }

  public static getConsentTypes(
    careType: CareType,
    referralAndIntakeToggle: boolean
  ): string[] {
    let keys = ["ALL_RECORDS", "ROI_CONSENT"];
    if (careType == CareType.Hospice && referralAndIntakeToggle) {
      keys.push("HOSPICE_ELECTION_FORM");
    }
    if (careType != CareType.Palliative) {
      keys.push("PUBLICATION_CAHPS");
    }
    if (referralAndIntakeToggle) {
      keys = keys.concat([
        "HEALTH_CARE_PROXY",
        "ACKNOWLEDGMENT_OF_CARE",
        "FINANCIAL_POWER_OF_ATTORNEY",
        "DURABLE_POWER_OF_ATTORNEY",
        "PROVIDER_REFERRAL_ORDERS",
      ]);
    }
    return keys;
  }

  public static calculateDocumentCompletion(
    careType: CareType,
    consentTypes: any[]
  ): string {
    const totalConsents = ReferralsServiceProvider.getConsentTypes(
      careType,
      true
    ).length;
    const completedConsents = consentTypes.filter(
      (consent) => String(consent.obtained) === "true"
    ).length;
    return `${completedConsents}/${totalConsents}`;
  }

  public createReferralSummaryWithIntakeMeds(
    medication: {
      name: string;
      dosage?: string;
      frequency?: string;
      route?: string;
      strength?: string;
      isFreeText: boolean;
    }[],
    patientChartId: number
  ) {
    return this.http.post<ReferralSummaryResult>(
      this.patientMedicationsUrl + patientChartId + "/medications/bulk",
      medication
    );
  }

  public getReferralSummary(
    patientChartId: number
  ): Observable<GetReferralSummaryResults> {
    return this.http.get<GetReferralSummaryResults>(
      this.configurationService.getConfig().apiUrl +
        "/patient-charts/" +
        patientChartId +
        "/referral-summary"
    );
  }

  public initiateReferralSummary(
    patientChartId: number,
    documentS3keys: number[]
  ) {
    const url =
      this.configurationService.getConfig().apiUrl +
      "/patient-charts/" +
      patientChartId +
      "/referral-summary/initiate";
    const data = {
      documentIds: documentS3keys,
    };

    return new Observable<SummaryInitiateResponse>((observer) =>
      this.http
        .post<SummaryInitiateResponse>(url, data, { headers: this.headers })
        .subscribe(
          (response) => {
            observer.next(response);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            observer.error(err);
            observer.complete();
          }
        )
    );
  }

  public getAsyncReferralSummary(
    patientChartId: number,
    referralSummaryId: number
  ) {
    return this.http.get<AsyncReferralSummary>(
      this.configurationService.getConfig().apiUrl +
        "/patient-charts/" +
        patientChartId +
        "/referral-summary/" +
        referralSummaryId
    );
  }

  public promptReferralSummary(
    patientChartId: number,
    referralSummaryId: number,
    isAccepted: boolean
  ) {
    return this.http.put<AsyncReferralSummary>(
      this.configurationService.getConfig().apiUrl +
        "/patient-charts/" +
        patientChartId +
        "/referral-summary/" +
        referralSummaryId,
      {
        isAccepted,
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/patient-charts/referrals-service.ts